import {
  useQuery,
  type UseQueryOptions,
  type UseQueryResult,
  type QueryKey,
} from '@tanstack/react-query';
import service from '../service';
import type { Flow } from '../types/flow';

type FlowResponse = Flow[];
type DefaultError = unknown;

type UseFlowParams = {
  /** Override default enabled behavior */
  enabled?: boolean;
};

export function useFlows<TData = FlowResponse, TError = DefaultError>(
  { enabled = true }: UseFlowParams = {},
  options?: Omit<
    UseQueryOptions<FlowResponse, TError, TData, QueryKey>,
    'queryKey' | 'queryFn' | 'enabled'
  >,
): UseQueryResult<TData, TError> {
  const queryKey: QueryKey = ['flow'];

  return useQuery<FlowResponse, TError, TData>({
    queryKey,
    enabled: enabled,
    queryFn: async () => {
      return service.getAllFlows();
    },
    ...(options as any),
  });
}
